<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click="on_click()">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M4 12.0871C4 12.6394 4.44772 13.0871 5 13.0871L11.2524 13.0871L9.62831 14.8748C9.28045 15.2577 9.28206 15.8427 9.63202 16.2237L9.68671 16.2832C10.0837 16.7154 10.7657 16.7145 11.1615 16.2812L15 12.0795L11.1476 7.88841C10.7513 7.45728 10.0711 7.4574 9.67492 7.88865L9.62072 7.94766C9.26961 8.32989 9.26929 8.91721 9.61999 9.29982L11.2581 11.0871L5 11.0871C4.44772 11.0871 4 11.5348 4 12.0871ZM13.6283 14.8748C13.2805 15.2577 13.2821 15.8427 13.632 16.2237L13.6867 16.2832C14.0837 16.7154 14.7657 16.7145 15.1615 16.2812L19 12.0795L15.1476 7.88841C14.7513 7.45728 14.0711 7.4574 13.6749 7.88865L13.6207 7.94766C13.2696 8.32989 13.2693 8.91721 13.62 9.29983L16.1677 12.0795L13.6283 14.8748Z" :fill="fill_color" :fill-opacity="opacity"/>
	</svg>
</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>
